import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, getHeaders } from '@urc-ui/store/api/base';
import { HttpMethod, Sort, Tag } from '@urc-ui/store/api/types';
import { GetAdvertisersInfoRequest, GetAdvertisersInfoResponse } from '@urc-ui/store/api/advertisers/types';
import { PREFETCH_ADVERTISER_COUNT } from '@urc-ui/store/constants';

export const DEFAULT_SORT_CONFIG: Sort = {
  columnName: 'SUBSCRIPTION_NAMESPACE',
  order: 'DESC'
};

export const buildGetAdvertiserInfoRequest = (advertiserIds: string[] = []) => {
  return {
    advertiserIds,
    sort: DEFAULT_SORT_CONFIG,
    pagination: {
      pageLimit: PREFETCH_ADVERTISER_COUNT,
      pageOffset: 0
    }
  };
};

export const advertiserInfoApi = createApi({
  reducerPath: 'advertiserInfoApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '/reports/api'
  }),
  tagTypes: [Tag.ADVERTISERS],
  endpoints: builder => ({
    getAdvertiserInfo: builder.query({
      query: (request: GetAdvertisersInfoRequest) => {
        return {
          url: '/advertisers',
          method: HttpMethod.POST,
          data: request,
          headers: getHeaders()
        };
      },
      transformResponse: (response: GetAdvertisersInfoResponse) => response,
      providesTags: [Tag.ADVERTISERS]
    })
  })
});

export const { useGetAdvertiserInfoQuery } = advertiserInfoApi;
